import React from 'react'

interface Td extends React.HTMLProps<HTMLTableCellElement> {
  isHeader?: boolean
  node?: any
}

export const Td: React.FC<Td> = ({ children, isHeader, node, ...props }) => (
  <td
    className="border dark:border-primary-700 text-primary-900 dark:text-primary-100 p-2"
    {...props}
  >
    {children}
  </td>
)

export default Td
